import { render, staticRenderFns } from "./product-card.component.vue?vue&type=template&id=be749600&"
import script from "./product-card.component.vue?vue&type=script&lang=ts&"
export * from "./product-card.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "product-card.component.vue"
export default component.exports